import React from 'react';
import { ListWrapper } from './helper/ListWrapper';
import { ListItem } from './ListItem';
var List = _ref => {
  var {
    children,
    colorToken = 'list/text-color',
    customBullet,
    id,
    itemSpaceToken,
    noStartPadding,
    ordered,
    testID,
    textToken = 'list/text-style',
    UNSAFE_props
  } = _ref;
  return /*#__PURE__*/React.createElement(ListWrapper, {
    id: id,
    testID: testID,
    ordered: ordered,
    UNSAFE_props: UNSAFE_props
  }, React.Children.map(children, (child, i) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
    colorToken: child.props.colorToken || colorToken,
    customBullet,
    index: 1 + i,
    isLast: React.Children.count(children) === i + 1,
    itemSpaceToken,
    noStartPadding,
    ordered,
    textToken: child.props.textToken || textToken
  }))));
};
List.displayName = 'List';
List.Item = ListItem;
export { List };
//# sourceMappingURL=index.js.map